<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="businessOrderform"
          status-icon
          :model="businessOrderform"
          :rules="rules"
          label-width="120px"
          class="businessOrderInfo"
          style="width: 90%"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="订单编号" prop="TransNo">
                <el-input v-model="businessOrderform.TransNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单金额" prop="PayMoney">
                <el-input v-model="businessOrderform.PayMoney"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支付类型" prop="PayType">
                <el-input v-model="businessOrderform.PayType"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付状态" prop="PayStateStr">
                <el-input v-model="businessOrderform.PayStateStr"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支付日期" prop="PayDate">
                <el-input v-model="businessOrderform.PayDate"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付时间" prop="PayTime">
                <el-input v-model="businessOrderform.PayTime"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商户单号" prop="ThirdOrderNo">
                <el-input v-model="businessOrderform.ThirdOrderNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交易流水号" prop="iRspRef">
                <el-input v-model="businessOrderform.iRspRef"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="退票时间" prop="ReturnTime">
                <el-input v-model="businessOrderform.ReturnTime"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
    </el-container>
  </div>
</template>

<script>
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "BusinessOrderInfoPage",
  data() {
    return {
      businessOrderform: {
        ScenicName: "",
        SaleSpotName: "",
        TransNo: "",
        PayMoney: "",
        PayType: "",
        PayState: "",
        PayStateStr:"",
        PayDate: "",
        PayTime: "",
        ThirdOrderNo: "",
        iRspRef: "",
        SettlementStatus: "",
        SettlementTime: "",
        ReturnTime: "",
      },
    };
  },
  components: {},
  props: {
    Order_No: {
      type: String,
      default: "",
    }
  },
  created: function () {
    this.init();
  },
  mounted: function () {},
  computed: {},
  methods: {
    // 初始化
    init() {
      this.GetInfo();
    },
    GetInfo() {
      if (this.Order_No) {
        showLoading(".zj-form-container");

        let BusinessSearch = {
          TransNo: this.Order_No,
        };
        return new WebApis.BusinessQueryOrderApi()
          .GetItemByTransNo(BusinessSearch)
          .then((res) => {
            console.log(res.data.Data);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.businessOrderform = this.resData;

              if(this.businessOrderform.PayState==1) this.businessOrderform.PayStateStr="支付成功";
              if(this.businessOrderform.PayState==2) this.businessOrderform.PayStateStr="退款成功";
              if(this.businessOrderform.PayState==3) this.businessOrderform.PayStateStr="退款失败";
              if(this.businessOrderform.PayState==4) this.businessOrderform.PayStateStr="待支付";
              if(this.businessOrderform.PayState==5) this.businessOrderform.PayStateStr="订单取消";
            }
            hideLoading();
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取商户订单信息失败!" + e.RspMsg
                : "获取商户订单信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
  },
};
</script>
